import showToast from '../Utils/ToastNotification';
import { userlogin } from '../Slice/AuthSlice';

export const isImpersonating = () => typeof window !== 'undefined' && sessionStorage.getItem('impersonating') === 'true';

export const restoreAdminAndNavigate = async (path, dispatch, navigate) => {
  try {
    const originalToken = sessionStorage.getItem('original_admin_token');
    if (!originalToken) {
      navigate('/admin/dashboard');
      return;
    }
    const originalRefresh = sessionStorage.getItem('original_admin_refresh_token');

    sessionStorage.setItem('auth_token', originalToken);
    sessionStorage.setItem('access_token', originalToken);
    if (originalRefresh) sessionStorage.setItem('refresh_token', originalRefresh);

    sessionStorage.removeItem('impersonating');
    sessionStorage.removeItem('impersonator_id');
    sessionStorage.removeItem('original_admin_token');
    sessionStorage.removeItem('original_admin_refresh_token');

    await dispatch(
      userlogin({
        token: originalToken,
        user: {},
        justRegistered: false,
      })
    );

    showToast('success', 'Restored admin session.');
    navigate(path);
  } catch (e) {
    navigate('/admin/dashboard');
  }
};
